import Header from './components/Header';
import Hero from './components/Hero';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import AppEntry from './components/AppEntry';
import Features from './components/Features';
import Ranking from './components/Ranking';
import FAQ from './components/FAQ';
import Media from './components/Media';
import Updates from './components/Updates';
import Topics from './components/Topics';
import Index from './components/Index';
import Cards from './components/Cards';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Carousel />
        <Comments />
        <AppEntry />
        <Features />
        <Ranking />
        <FAQ />
        <Media />
        <Updates />
        <Topics />
        <Index />
        <Cards />
        <Contact />
        <About />
      </main>
      <Footer />
    </div>
  );
}